var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"path-planning"},[_c('iframe',{attrs:{"src":_vm.pathPlanningUrl,"width":"100%","height":"100%","frameborder":"0"}})])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }